import $ from 'jquery';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';

export default class CustomMap {
    constructor(
        mapID,
        {
            center = [50.835432306955276, 4.281921386718751],
            zoomLevel = 12,
            showZoomControls = true,
            allowZoom = true,
            useClusters = true,
            getPopupContentFunction = null,
        }
    ) {
        this.map = null;

        this.itemsCoordinates = [];

        this.mapID = mapID;
        this.center = center;
        this.zoomLevel = zoomLevel;

        this.showZoomControls = showZoomControls;
        this.allowZoom = allowZoom;
        this.useClusters = useClusters;

        this.getPopupContent = getPopupContentFunction;

        if (this.useClusters) {
            this.markers = L.markerClusterGroup();
        } else {
            this.markers = L.layerGroup();
        }
    }

    // Display the map
    displayMap() {
        if (this.map) {
            this.map.remove();
        }

        // Initialize Leaflet map
        this.map = L.map(this.mapID, {
            center: L.latLng(this.center),
            zoom: this.zoomLevel,
            zoomControl: this.showZoomControls,
            scrollWheelZoom: this.allowZoom,
        });

        // Add OpenStreetMap tile layer
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 18,
        }).addTo(this.map);

        if (this.showZoomControls) {
            // Set position of zoom control based on window width
            this.setControlPosition();

            // Realign control position on window resize
            $(window).on('resize', (e) => {
                this.setControlPosition();
            });
        }

        // this.map.on('click', (ev) => {
        // 	console.log(ev.latlng);
        // 	console.log(this.map.getCenter());
        // });
    }

    // Display markers on the map
    displayMarkers(items) {
        if (items.length) {
            // Add markers for each item
            items.map((item) => {
                this.itemsCoordinates.push([item.lat, item.lng]);

                const marker = this.addMarker(item);

                this.useClusters
                    ? this.markers.addLayer(marker)
                    : marker.addTo(this.map);
            });

            this.fitMarkers();

            if (this.useClusters) {
                // Add markers to map
                this.map.addLayer(this.markers);
            }
        }
    }

    fitMarkers() {
        // Fit map bounds to markers
        const bounds = L.latLngBounds(this.itemsCoordinates);
        this.map.fitBounds(bounds, { maxZoom: this.zoomLevel });
    }

    centerOnMarker(position, zoom = 12, animate = false) {
        if (animate) {
            this.map.flyTo(position, zoom, { duration: 0.6 });
        } else {
            this.map.setView(position, zoom);
        }
    }

    // Add individual marker to the map
    addMarker(item) {
        const lat = item.lat;
        const lng = item.lng;
        const color = item.color;

        // Custom marker icon
        const customIcon = L.divIcon({
            className: 'custom-div-icon',
            html: `<svg width="32" height="43" viewBox="0 0 32 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0C11.7565 0 7.68687 1.67129 4.68629 4.6462C1.68571 7.62112 0 11.656 0 15.8631C0 24.6202 16 43 16 43C16 43 32 24.6202 32 15.8631C32 11.656 30.3143 7.62112 27.3137 4.6462C24.3131 1.67129 20.2435 0 16 0ZM16 22.4352C14.4913 22.4352 13.0164 21.9917 11.7619 21.1606C10.5075 20.3296 9.52975 19.1483 8.95239 17.7664C8.37501 16.3845 8.22395 14.8638 8.51829 13.3967C8.81263 11.9296 9.53915 10.582 10.606 9.52429C11.6728 8.46658 13.0321 7.74628 14.5117 7.45445C15.9916 7.16263 17.5253 7.31241 18.9192 7.88483C20.3131 8.45725 21.5045 9.42663 22.3427 10.6704C23.1809 11.9141 23.6283 13.3763 23.6283 14.8722C23.6283 16.878 22.8245 18.8016 21.394 20.2201C19.9635 21.6384 18.0232 22.4352 16 22.4352Z" fill="${color}"/></svg>`,
            iconSize: [24, 32],
            iconAnchor: [12, 32],
        });

        // Popup content for marker
        const popupContent = this.getPopupContent(item);

        return L.marker([lat, lng], { icon: customIcon }).bindPopup(popupContent, {
            maxWidth: this.maxPopUpWidth,
        });
    }

    // Set position of zoom control based on window width
    setControlPosition() {
        this.map.zoomControl.setPosition(
            window.innerWidth < 1920 ? 'bottomright' : 'topright'
        );
    }
}